import {
  ExpenseSubmitData,
  PaymentConfigCategory,
  PaymentConfigSubcategory,
} from '../../models/paymentConfig';
import { SavePaymentSubmissionResponse } from '../../models/paymentSubmissions';
import savePaymentSubmission from '../../services/paymentSubmissions/savePaymentSubmission';

export const savePaymentSubmissionWithProgress = async (
  protocolId: string,
  paymentCategory: PaymentConfigCategory,
  paymentSubcategory: PaymentConfigSubcategory,
  expenses: ExpenseSubmitData[]
) => {
  const paymentSubmissions: Promise<SavePaymentSubmissionResponse>[] = [];

  if (paymentSubcategory.amount > 0) {
    paymentSubmissions.push(
      savePaymentSubmission({
        protocolId,
        paymentCategoryId: paymentCategory.id,
        paymentSubcategoryId: paymentSubcategory.id,
      })
    );
  }

  paymentSubmissions.push(
    ...expenses.map((expense) =>
      savePaymentSubmission({
        protocolId,
        paymentCategoryId: paymentCategory.id,
        paymentSubcategoryId: paymentSubcategory.id,
        expense,
      })
    )
  );

  return Promise.all(paymentSubmissions);
};
